module.exports = __webpack_public_path__ + "img/pasos1-4.da756f46.png";